import React, { Fragment, useState } from 'react';
import { useCookies } from 'react-cookie';
import { CONSENT_COOKIE_KEY } from '../../rutab-constants';
import { CookieModal } from './CookieModal';
import { ConsentAllCookies, CookieConsentNotInitzialized } from './CookieConsent.action';
import { translate } from '../../Services/translation';

export const CookieConsent = () => {
    const [cookies, setCookie] = useCookies([CONSENT_COOKIE_KEY]);
    const [modalIsOpen, setIsOpen] = useState(false);

    let cookieMenu = document.querySelector('#open-cookie-settings-modal');
    if (cookieMenu) {
        cookieMenu.addEventListener('click', () => {
            setIsOpen(true);
        })
    }

    return (
        <Fragment>
            {CookieConsentNotInitzialized(cookies) &&
                <div className="cookie-consent position-fixed">
                    <div className="desktop-container mt-2 mb-2">
                        <p>{translate('cookie.intro.text')} <a href="/policy" className="simple-link-underline">{translate('cookie.policy.link.text')}</a></p>
                        <button className="banner-text__button" onClick={() => ConsentAllCookies(setCookie)}>{translate('cookie.accept.all')}</button>
                        <button className="button link" onClick={setIsOpen}>{translate('cookie.open.cookie.settings')}</button>
                    </div>
                </div>
            }
            {modalIsOpen &&
                <CookieModal
                    onRequestClose={() => setIsOpen(false)}
                />
            }
        </Fragment>
    )
};

export default CookieConsent;